import Tr from 'translations/Translations';

const createItem = (label, value) => ({
	label,
	value
})

export const VARIANT_CODE = {
	TEXT: 'TEXT',
	LIST: 'LIST',
	NUMBER: 'NUMBER',
	YESNO: 'YESNO',
	INTERVAL: 'INTERVAL',
	PRICE: 'PRICE',
}

export const criteriaLabels = {
	[VARIANT_CODE.TEXT]: Tr('text'),
	[VARIANT_CODE.YESNO]: `${Tr('yes')}/${Tr('no')}`,
	[VARIANT_CODE.NUMBER]: Tr('number'),
	[VARIANT_CODE.LIST]: Tr('list'),
	[VARIANT_CODE.INTERVAL]: Tr('allocation'),
	[VARIANT_CODE.PRICE]: Tr('price'),
}

export default Object.keys(criteriaLabels).map( x => createItem(criteriaLabels[x], x))
